import React from "react";

const VerticalMeter = ({
  value = 0,
  max = 100,
  label = "",
  warningThreshold = 70,
  dangerThreshold = 90,
  size = 200,
}) => {
  const percentage = Math.min((value / max) * 100, 100);

  const trackHeight = size - 40;
  const fillHeight = (percentage / 100) * trackHeight;

  return (
    <div className="flex flex-col items-center justify-end">
      {/* VALUE (fixed height) */}
      <div className="h-10 flex items-end justify-center">
        <span
          className={`text-2xl font-bold ${
            percentage >= dangerThreshold
              ? "text-red-500"
              : percentage >= warningThreshold
              ? "text-amber-500"
              : "text-emerald-500"
          }`}
        >
          {value}
        </span>
      </div>

      {/* BAR */}
      <div className="relative w-7" style={{ height: trackHeight }}>

        {/* Track */}
        <div
          className="absolute bottom-0 left-0 w-full rounded-full
                     bg-zinc-200 dark:bg-zinc-800
                     border border-zinc-300 dark:border-zinc-700"
          style={{ height: trackHeight }}
        />

        {/* Fill */}
        <div
          className="absolute bottom-0 left-0 w-full rounded-full
                     transition-all duration-700 ease-out"
          style={{
            height: fillHeight,
            backgroundImage:
              "linear-gradient(to top, #065f46 0%, #10b981 30%, #f59e0b 60%, #ef4444 85%, #991b1b 100%)",
            backgroundSize: `100% ${trackHeight}px`,
            backgroundPosition: "bottom",
            boxShadow:
              percentage >= dangerThreshold
                ? "0 0 12px rgba(239,68,68,0.45)"
                : percentage >= warningThreshold
                ? "0 0 12px rgba(245,158,11,0.45)"
                : "0 0 12px rgba(16,185,129,0.45)",
          }}
        />
      </div>

      {/* LABEL (fixed height, center aligned) */}
      <div className="mt-3 h-10 flex items-start text-center">
        <span className="text-xs tracking-wide uppercase text-muted-foreground">
          {label}
        </span>
      </div>
    </div>
  );
};

export default VerticalMeter;
